<template>
  <div class="component-block">
    <div class="component-block--heading">
      <h3>{{ `${data.id} ${data.component.replace('Component', '')}` }}</h3>
      
      <RoundedButton
        title=""
        danger=true
        v-on:handleClick="$emit('handleDeleteClick')"
      >
        <TrashIcon/>
      </RoundedButton>

      <RoundedButton
        title="Edit"
        v-on:handleClick="handleModal"
      >
        <EditIcon/>
      </RoundedButton>
    </div>
    
    <div class="component-block--content">
      <!-- title -->
      <div
        v-if="data.title !== ''"
        class="component-block--content--title"
      >
        <p class="bold">Title</p>
        <p>{{ data.title }}</p>
      </div>
      
      <!-- content -->
      <div v-if="data.content !== ''">
        <p class="bold">Content</p>
        <p v-html="data.content"></p>
      </div>

      <!-- Media -->
      <div v-if="data.image !== ''">
        <p class="bold">Media</p>
        
        <img :src="data.image" />
      </div>

      <div v-if="data.videopreview !== ''">
        <p class="bold">Media</p>
        
        <img :src="data.videopreview" />
      </div>

      <div v-if="data.audio !== ''">
        <p class="bold">Media</p>
        
        <Audio
          :audio="data.audio"
          type="audio/mp3"
        />
      </div>

      <!-- type -->
      <div v-if="data.type !== ''">
        <p class="bold">Type</p>
        <p>{{ data.type }}</p>
      </div>

      <!-- questiondef -->
      <!-- answer -->      
      <div v-if="
        data.component === 'AnswerDisplayComponent'
        && data.questiondef.options !== undefined
      ">
        <p class="bold">Answers</p>
        
        <div
          v-for="(item, index) in data.questiondef.options"
          v-bind:key="index"
          class="component-block--content--array"
        >
          <p class="bold">Page ID</p>
          <p>{{ item.page }}</p>

          <div>
            <p class="bold">Component ID</p>
            <p>{{ item.excercise }}</p>
          </div>          
        </div>        
      </div>

      <!-- Checkbox -->
      <div v-if="
        data.component === 'CheckboxComponent'
        && data.questiondef.options != undefined
      ">
        <p class="bold">Checkboxes</p>
        
        <div
          v-for="(item, index) in data.questiondef.options"
          v-bind:key="index"
          class="component-block--content--array"
        >
          <p class="bold">Label</p>
          <p>{{ item.label }}</p>

          <div>
            <p class="bold">Feedback</p>
            <p>{{ item.feedback }}</p>
          </div>
          
          <div>
            <p class="bold">Type</p>
            <p v-if="item.result === false || item.result === 0">Wrong</p>
            <p v-if="item.result === true || item.result === 1">Correct</p>
          </div>
        </div>
      </div>

      <!-- Draganddrop -->
      <div v-if="
        data.component === 'DragAndDropComponent'
        && data.questiondef.options !== undefined
      ">
        <p class="bold">Answers</p>
        
        <div
          v-for="(item, index) in data.questiondef.options"
          v-bind:key="index"
          class="component-block--content--array"
        >
          <p class="bold">Label</p>
          <p>{{ item.label }}</p>

          <div>
            <p class="bold">Feedback</p>
            <p>{{ item.feedback }}</p>
          </div>

          <div>
            <p class="bold">Type</p>
            <p v-if="item.result === 0">Wrong</p>
            <p v-if="item.result === 1">Correct</p>
          </div>          
        </div>
      </div>

      <!-- Radio -->
      <div v-if="
        data.component === 'RadioComponent'
        && data.questiondef.options !== undefined
      ">
        <p class="bold">Radios</p>
        
        <div
          v-for="(item, index) in data.questiondef.options"
          v-bind:key="index"
          class="component-block--content--array"
        >
          <p class="bold">Label</p>
          <p>{{ item.label }}</p>

          <div>
            <p class="bold">Feedback</p>
            <p>{{ item.feedback }}</p>
          </div>

          <div>
            <p class="bold">Type</p>
            <p v-if="item.result === -1">Neutral</p>
            <p v-if="item.result === 0">Wrong</p>
            <p v-if="item.result === 1">Correct</p>
          </div>          
        </div>        
      </div>

      <!-- Slide -->
      <div v-if="
        data.component === 'SliderComponent'
        && data.questiondef.options !== undefined
      ">
        <p class="bold">Slides</p>
        
        <div
          v-for="(item, index) in data.questiondef.options"
          v-bind:key="index"
          class="component-block--content--array"
        >
          <p class="bold">Label</p>
          <p>{{ item.label }}</p>

          <div>
            <p class="bold">Step</p>
            <p>{{ item.step }}</p>
          </div>

          <div>
            <p class="bold">Min value</p>
            <p>{{ item.minvalue }}</p>
          </div>

          <div>
            <p class="bold">Max value</p>
            <p>{{ item.maxvalue }}</p>
          </div>

          <div>
            <p class="bold">Min label</p>
            <p>{{ item.minlabel }}</p>
          </div>

          <div>
            <p class="bold">Max label</p>
            <p>{{ item.maxlabel }}</p>
          </div>
        </div>
      </div>

      <!-- Text -->
      <div v-if="
        (
          data.component === 'TextareaComponent'
          || data.component === 'TextfieldComponent'
        )
        && data.questiondef.options !== undefined
      ">
        <p class="bold">Texts</p>
        
        <div
          v-for="(item, index) in data.questiondef.options"
          v-bind:key="index"
          class="component-block--content--array"
        >
          <p class="bold">Placeholder</p>
          <p>{{ item.label }}</p>

          <div>
            <p class="bold">Comment</p>
            <p>{{ item.comment }}</p>
          </div>
        </div>
      </div>

      <!-- Wordgrid -->
      <div v-if="
        data.component === 'WordgridComponent'
        && data.questiondef.options !== undefined
      ">
        <p class="bold">Words</p>
        
        <div
          v-for="(item, index) in data.questiondef.options"
          v-bind:key="index"
          class="component-block--content--array"
        >
          <p class="bold">Text</p>
          <p>{{ item.label }}</p>
        </div>
      </div>

      <!-- feedback -->
      <div v-if="
        data.component === 'TestComponent'
        && data.questiondef.feedback.positive !== ''
      ">
        <p class="bold">Positive feedback</p>
        <p>{{ data.questiondef.feedback.positive }}</p>
      </div>

      <div v-if="
        data.component === 'TestComponent'
        && data.questiondef.feedback.negative !== ''
      ">
        <p class="bold">Negative feedback</p>
        <p>{{ data.questiondef.feedback.negative }}</p>
      </div>

      <!-- Test -->
      <div v-if="
        data.component === 'TestComponent'        
        && data.questiondef.choices !== undefined
      ">
        <p class="bold">Questions</p>
        
        <div
          v-for="(item, index) in data.questiondef.choices"
          v-bind:key="index"
          class="component-block--content--array"
        >
        <div></div>
          <p class="bold">Question</p>
          <p>{{ item.label }}</p>

          <div>
            <p class="bold">
              Placeholder false
            </p>

            <p>{{ item.options[0].option }}</p>
          </div>
          
          <div>
            <p class="bold">
              Placeholder true
            </p>

            <p>{{ item.options[1].option }}</p>
          </div>
        </div>
      </div>
    </div>

    <Modal
      closeIcon="true"
      v-on:close="handleModal"
      v-if="!modal.isHidden"
      draggable="true"
      ondragstart="event.preventDefault(); event.stopPropagation();"
    >
      <template v-slot:title>
        <h3>{{ `${data.id} ${data.component.replace('Component', '')}` }}</h3>
      </template>

      <template v-slot:content>
        <form> 
          <!-- PageComponent -->
          <div
            class="row"
            v-if="data.component === 'PageComponent'"
          >
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.pageComponent.header"
              v-model="modal.pageComponent.header"
            />

            <div class="col-24 input">
              <p>Content</p>

              <vue-mce
                :config="config"
                v-model="modal.pageComponent.content"
              />
            </div>

            <!-- media -->
            <div class="col-12 input">
              <p>Media</p>

              <ButtonForm
                class="component-block--array-button"
                title="Select media"
                v-on:handleClick="handleModalMedia()"
              />
            </div>

            <div class="col-12 input">
              <p>Selected media</p>

              <RatioBlockImage
                v-if="modal.pageComponent.image !== ''"
                class="motivator-image"
                :src="modal.pageComponent.image"
              />

              <RatioBlockImage
                v-else-if="
                  modal.pageComponent.videopreview !== ''
                  && modal.pageComponent.videopreview !== undefined
                "
                class="motivator-image"
                :src="modal.pageComponent.videopreview"
              />

              <Audio
                v-else-if="modal.pageComponent.audio !== ''"
                :audio="modal.pageComponent.audio"
                type="audio/mp3"
              />

              <div v-else>
                No media selected
              </div>

              <ButtonForm
                v-if="modal.pageComponent.image !== ''"
                class="component-block--remove-button"
                title="Remove image"
                v-on:handleClick="handleModalRemoveMedia()"
              />

              <ButtonForm
                v-if="
                  modal.pageComponent.videopreview !== ''
                  && modal.pageComponent.videopreview !== undefined
                "
                class="component-block--remove-button"
                title="Remove video"
                v-on:handleClick="handleModalRemoveMedia()"
              />

              <ButtonForm
                v-if="modal.pageComponent.audio !== ''"
                class="component-block--remove-button"
                title="Remove audio"
                v-on:handleClick="handleModalRemoveMedia()"
              />
            </div>

            <Modal
              closeIcon="true"
              v-on:close="handleModalMedia()"
              v-if="!modalMedia.isHidden"
            >
              <template v-slot:title>
                <h3>Select media</h3>
              </template>

              <template v-slot:content>
                <tabs>
                  <tab name="Images">
                    <SelectionModuleImage v-on:handleClick="handleSelectionModuleImageClick"/>
                  </tab>

                  <tab name="Videos">
                    <SelectionModuleVideo v-on:handleClick="handleSelectionModuleVideoClick"/>
                  </tab>

                  <tab name="Audio">
                    <SelectionModuleMP3 v-on:handleClick="handleSelectionModuleMP3Click"/>
                  </tab>
                </tabs>
              </template>
            </Modal>

            <!-- type -->
            <div class="col-12 input">
              <p>Type</p>

              <RadioInput
                placeholder="Standard"
                name="radio"
                :checked="handleRadioChecked('standard')"
                v-on:handleClick="handleRadioInput('standard')"
              />

              <RadioInput
                placeholder="Tips"
                name="radio"
                :checked="handleRadioChecked('tips')"
                v-on:handleClick="handleRadioInput('tips')"
              />

              <RadioInput
                placeholder="Examples"
                name="radio"
                :checked="handleRadioChecked('examples')"
                v-on:handleClick="handleRadioInput('examples')"
              />

              <RadioInput
                placeholder="More info"
                name="radio"
                :checked="handleRadioChecked('moreinfo')"
                v-on:handleClick="handleRadioInput('moreinfo')"
              />
            </div>
          </div>
          
          <!-- AnswerDisplayComponent -->
          <div
            class="row"
            v-if="data.component === 'AnswerDisplayComponent'"
          >
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.answerDisplayComponent.header"
              v-model="modal.answerDisplayComponent.header"
            />

            <div class="col-24">
              <div
                v-if="modal.answerDisplayComponent.questiondef.options.length === 0"
                class="component-block--array"
              >
                <div class="row">
                  <Input
                    class="col-24"
                    placeholder="Page id"
                    type="number"
                    value="0"
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <Input
                    class="col-24"
                    placeholder="Component id"
                    type="number"
                    value="0"
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />
                </div>
              </div>

              <div
                v-for="(item, index) in modal.answerDisplayComponent.questiondef.options"
                v-bind:key="index"
                class="component-block--array"
              >
                <div class="row">
                  <div class="component-block--array--buttons">
                    <a
                      v-if="index !== modal.answerDisplayComponent.questiondef.options.length - 1"
                      class="component-block--array--buttons--down"
                      v-on:click="handleComponentBlockArray(modal.answerDisplayComponent.questiondef.options, item, index, false)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a
                      v-if="index !== 0"
                      class="component-block--array--buttons--up"
                      v-on:click="handleComponentBlockArray(modal.answerDisplayComponent.questiondef.options, item, index, true)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a 
                      class="component-block--array--buttons--trash"
                      v-on:click="handleArrayButtonDelete()"
                    >
                      <TrashIcon/>
                    </a>
                  </div>
                  
                  <Input
                    class="col-24"
                    placeholder="Page id"
                    type="number"
                    :value="item.page"
                    v-model="modal.answerDisplayComponent.questiondef.options[index].page"
                  />

                  <Input
                    class="col-24"
                    placeholder="Component id"
                    type="number"
                    :value="item.excercise"
                    v-model="modal.answerDisplayComponent.questiondef.options[index].excercise"                  
                  />
                </div>
              </div>
            </div>
  
            <div class="col-24">
              <ButtonForm
                class="component-block--array-button"
                title="Add answer"
                v-on:handleClick="handleArrayButtonAdd()"
              />
            </div>
          </div>

          <!-- CheckBoxComponent -->
          <div
            class="row"
            v-if="data.component === 'CheckboxComponent'"
          >
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.checkBoxComponent.header"
              v-model="modal.checkBoxComponent.header"
            />
            
            <Input
              class="col-12"
              placeholder="Max allow"
              type="number"
              :value="modal.checkBoxComponent.questiondef.meta.maxAllowAdd"
              v-model="modal.checkBoxComponent.questiondef.meta.maxAllowAdd"
            />

            <div class="col-12 input">
              <p>Allow add</p>

              <SwitchForm 
                :isActive="modal.checkBoxComponent.questiondef.meta.allowAdd"
                v-model="modal.checkBoxComponent.questiondef.meta.allowAdd"
              />
            </div>

            <div class="col-24">
              <div
                v-if="modal.checkBoxComponent.questiondef.options.length === 0"
                class="component-block--array"
              >
                <div class="row">
                  <Input
                    class="col-24"
                    placeholder="Label"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <Input
                    class="col-24"
                    placeholder="Feedback"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <div class="col-24 input">
                    <p>Type</p>
                    
                    <RadioInput
                      placeholder="Wrong"
                      :name="`handleRadioInputCheckboxComponent`"
                      :checked="false"
                      v-on:handleClick="handlePlaceholderArrayInputs()"
                    />
                    
                    <RadioInput
                      placeholder="Correct"
                      :name="`handleRadioInputCheckboxComponent`"
                      :checked="false"
                      v-on:handleClick="handlePlaceholderArrayInputs()"
                    />
                  </div>
                </div>
              </div>

              <div
                v-for="(item, index) in modal.checkBoxComponent.questiondef.options"
                v-bind:key="index"
                class="component-block--array"
              >
                <div class="row">
                  <div class="component-block--array--buttons">
                    <a
                      v-if="index !== modal.checkBoxComponent.questiondef.options.length - 1"
                      class="component-block--array--buttons--down"
                      v-on:click="handleComponentBlockArray(modal.checkBoxComponent.questiondef.options, item, index, false)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a
                      v-if="index !== 0"
                      class="component-block--array--buttons--up"
                      v-on:click="handleComponentBlockArray(modal.checkBoxComponent.questiondef.options, item, index, true)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a 
                      class="component-block--array--buttons--trash"
                      v-on:click="handleArrayButtonDelete()"
                    >
                      <TrashIcon/>
                    </a>
                  </div>

                  <Input
                    class="col-24"
                    placeholder="Label"
                    type="text"
                    :value="item.label"
                    v-model="modal.checkBoxComponent.questiondef.options[index].label"
                  />

                  <Input
                    class="col-24"
                    placeholder="Feedback"
                    type="text"
                    :value="item.feedback"
                    v-model="modal.checkBoxComponent.questiondef.options[index].feedback"
                  />

                  <div class="col-24 input">
                    <p>Type</p>

                    <RadioInput
                      placeholder="Wrong"
                      :name="`handleRadioInputCheckboxComponent${index}`"
                      :checked="item.result === false || item.result === 0"
                      v-on:handleClick="handleRadioInputCheckboxComponent(false, index)"
                    />
                    
                    <RadioInput
                      placeholder="Correct"
                      :name="`handleRadioInputCheckboxComponent${index}`"
                      :checked="item.result === true || item.result === 1"
                      v-on:handleClick="handleRadioInputCheckboxComponent(true, index)"
                    />
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col-24">
              <ButtonForm
                class="component-block--array-button"
                title="Add checkbox"
                v-on:handleClick="handleArrayButtonAdd()"
              />
            </div>
          </div>

          <!-- DragAndDropComponent -->
          <div
            class="row"
            v-if="data.component === 'DragAndDropComponent'"
          >
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.dragAndDropComponent.header"
              v-model="modal.dragAndDropComponent.header"
            />

            <Input
              class="col-12"
              placeholder="Max allow"
              type="number"
              :value="modal.dragAndDropComponent.questiondef.meta.maxAllowAdd"
              v-model="modal.dragAndDropComponent.questiondef.meta.maxAllowAdd"
            />

            <div class="col-12 input">
              <p>Allow add</p>

              <SwitchForm 
                :isActive="modal.dragAndDropComponent.questiondef.meta.allowAdd"
                v-model="modal.dragAndDropComponent.questiondef.meta.allowAdd"
              />
            </div>
            
            <div class="col-24">
              <div
                v-if="modal.dragAndDropComponent.questiondef.options.length === 0"
                class="component-block--array"
              >
                <Input
                  placeholder="Label"
                  type="text"
                  value=""
                  v-on:handleFocus="handlePlaceholderArrayInputs()"
                />

                <Input
                  placeholder="Feedback"
                  type="text"
                  value=""
                  v-on:handleFocus="handlePlaceholderArrayInputs()"
                />

                <div class="input">
                  <p>Type</p>

                  <RadioInput
                    placeholder="Wrong"
                    :name="`handleRadioInputCheckboxComponent`"
                    :checked="true"
                    v-on:handleClick="handlePlaceholderArrayInputs()"
                  />
                  
                  <RadioInput
                    placeholder="Correct"
                    :name="`handleRadioInputCheckboxComponent`"
                    :checked="false"
                    v-on:handleClick="handlePlaceholderArrayInputs()"
                  />
                </div>
              </div>

              <div
                v-for="(item, index) in modal.dragAndDropComponent.questiondef.options"
                v-bind:key="index"
                class="component-block--array"
              >
                <div class="row">
                  <div class="component-block--array--buttons">
                    <a
                      v-if="index !== modal.dragAndDropComponent.questiondef.options.length - 1"
                      class="component-block--array--buttons--down"
                      v-on:click="handleComponentBlockArray(modal.dragAndDropComponent.questiondef.options, item, index, false)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a
                      v-if="index !== 0"
                      class="component-block--array--buttons--up"
                      v-on:click="handleComponentBlockArray(modal.dragAndDropComponent.questiondef.options, item, index, true)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a 
                      class="component-block--array--buttons--trash"
                      v-on:click="handleArrayButtonDelete()"
                    >
                      <TrashIcon/>
                    </a>
                  </div>

                  <Input
                    class="col-24"
                    placeholder="Label"
                    type="text"
                    :value="item.label"
                    v-model="modal.dragAndDropComponent.questiondef.options[index].label"
                  />

                  <Input
                    class="col-24"
                    placeholder="Feedback"
                    type="text"
                    :value="item.feedback"
                    v-model="modal.dragAndDropComponent.questiondef.options[index].feedback"
                  />

                  <div class="col-24 input">
                    <p>Type</p>

                    <RadioInput
                      placeholder="Wrong"
                      :name="`dragAndDropComponent${index}`"
                      :checked="item.result === 0"
                      v-on:handleClick="handleRadioInputDragAndDropComponent(0, index)"
                    />
                    
                    <RadioInput
                      placeholder="Correct"
                      :name="`dragAndDropComponent${index}`"
                      :checked="item.result === 1"
                      v-on:handleClick="handleRadioInputDragAndDropComponent(1, index)"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-24">
              <ButtonForm
                class="component-block--array-button"
                title="Add drag and drop"
                v-on:handleClick="handleArrayButtonAdd()"
              />
            </div>
          </div>

          <!-- FeedbackComponent -->
          <div
            class="row"
            v-if="data.component === 'FeedbackComponent'"
          >
            <div class="col-12 input">
              <p>Rating</p>

              <StarInput :number="0"/>
            </div>
          </div>

          <!-- RadioComponent -->
          <div
            class="row"
            v-if="data.component === 'RadioComponent'"
          >
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.radioComponent.header"
              v-model="modal.radioComponent.header"
            />

            <Input
              class="col-12"
              placeholder="Max allow"
              type="number"
              :value="modal.radioComponent.questiondef.meta.maxAllowAdd"
              v-model="modal.radioComponent.questiondef.meta.maxAllowAdd"
            />

            <div class="col-12 input">
              <p>Allow add</p>

              <SwitchForm 
                :isActive="modal.radioComponent.questiondef.meta.allowAdd"
                v-model="modal.radioComponent.questiondef.meta.allowAdd"
              />
            </div>

            <div class="col-24">
              <div
                v-if="modal.radioComponent.questiondef.options.length === 0"
                class="component-block--array"
              >
                <div class="row">
                  <Input
                    class="col-24"
                    placeholder="Label"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <Input
                    class="col-24"
                    placeholder="Feedback"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <div class="col-24 input">
                    <p>Result</p>

                    <RadioInput
                      placeholder="Neutral"
                      :name="`radioComponent`"
                      :checked="false"
                      v-on:handleClick="handlePlaceholderArrayInputs()"
                    />

                    <RadioInput
                      placeholder="Wrong"
                      :name="`radioComponent`"
                      :checked="false"
                      v-on:handleClick="handlePlaceholderArrayInputs()"
                    />
                    
                    <RadioInput
                      placeholder="Correct"
                      :name="`radioComponent`"
                      :checked="false"
                      v-on:handleClick="handlePlaceholderArrayInputs()"
                    />
                  </div>
                </div>
              </div>

              <div
                v-for="(item, index) in modal.radioComponent.questiondef.options"
                v-bind:key="index"
                class="component-block--array"
              >
                <div class="row">
                  <div class="component-block--array--buttons">
                    <a
                      v-if="index !== modal.radioComponent.questiondef.options.length - 1"
                      class="component-block--array--buttons--down"
                      v-on:click="handleComponentBlockArray(modal.radioComponent.questiondef.options, item, index, false)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a
                      v-if="index !== 0"
                      class="component-block--array--buttons--up"
                      v-on:click="handleComponentBlockArray(modal.radioComponent.questiondef.options, item, index, true)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a 
                      class="component-block--array--buttons--trash"
                      v-on:click="handleArrayButtonDelete()"
                    >
                      <TrashIcon/>
                    </a>
                  </div>

                  <Input
                    class="col-24"
                    placeholder="Label"
                    type="text"
                    :value="item.label"
                    v-model="modal.radioComponent.questiondef.options[index].label"
                  />

                  <Input
                    class="col-24"
                    placeholder="Feedback"
                    type="text"
                    :value="item.feedback"
                    v-model="modal.radioComponent.questiondef.options[index].feedback"
                  />

                  <div class="col-24 input">
                    <p>Result</p>

                    <RadioInput
                      placeholder="Neutral"
                      :name="`radioComponent${index}`"
                      :checked="item.result === -1"
                      v-on:handleClick="handleRadioInputRadioComponent(-1, index)"
                    />

                    <RadioInput
                      placeholder="Wrong"
                      :name="`radioComponent${index}`"
                      :checked="item.result === 0"
                      v-on:handleClick="handleRadioInputRadioComponent(0, index)"
                    />
                    
                    <RadioInput
                      placeholder="Correct"                    
                      :name="`radioComponent${index}`"
                      :checked="item.result === 1"
                      v-on:handleClick="handleRadioInputRadioComponent(1, index)"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-24">
              <ButtonForm
                class="component-block--array-button"
                title="Add radio"
                v-on:handleClick="handleArrayButtonAdd()"
              />
            </div>
          </div>

          <!-- SliderComponent -->
          <div
            class="row"
            v-if="data.component === 'SliderComponent'"
          >
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.sliderComponent.header"
              v-model="modal.sliderComponent.header"
            />
            
            <div class="col-24">
              <div
                v-if="modal.sliderComponent.questiondef.options.length === 0"
                class="component-block--array"
              >
                <div class="row">
                  <Input
                    class="col-24"
                    placeholder="Label"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <Input
                    class="col-24"
                    placeholder="Step value"
                    type="number"
                    value="0"
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <Input
                    class="col-24"
                    placeholder="Min value"
                    type="number"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <Input
                    class="col-24"
                    placeholder="Max value"
                    type="number"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <Input
                    class="col-24"
                    placeholder="Min title"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <Input
                    class="col-24"
                    placeholder="Max title"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />
                </div>
              </div>
              
              <div
                v-for="(item, index) in modal.sliderComponent.questiondef.options"
                v-bind:key="index"
                class="component-block--array"
              >
                <div class="row">
                  <div class="component-block--array--buttons">
                    <a
                      v-if="index !== modal.sliderComponent.questiondef.options.length - 1"
                      class="component-block--array--buttons--down"
                      v-on:click="handleComponentBlockArray(modal.sliderComponent.questiondef.options, item, index, false)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a
                      v-if="index !== 0"
                      class="component-block--array--buttons--up"
                      v-on:click="handleComponentBlockArray(modal.sliderComponent.questiondef.options, item, index, true)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a 
                      class="component-block--array--buttons--trash"
                      v-on:click="handleArrayButtonDelete()"
                    >
                      <TrashIcon/>
                    </a>
                  </div>

                  <Input
                    class="col-24"
                    placeholder="Label"
                    type="text"
                    :value="item.label"
                    v-model="modal.sliderComponent.questiondef.options[index].label"
                  />

                  <Input
                    class="col-24"
                    placeholder="Step value"
                    type="number"
                    :value="item.step"
                    v-model="modal.sliderComponent.questiondef.options[index].step"
                  />

                  <Input
                    class="col-24"
                    placeholder="Min value"
                    type="number"
                    :value="item.minvalue"
                    v-model="modal.sliderComponent.questiondef.options[index].minvalue"
                  />

                  <Input
                    class="col-24"
                    placeholder="Max value"
                    type="number"
                    :value="item.maxvalue"
                    v-model="modal.sliderComponent.questiondef.options[index].maxvalue"
                  />

                  <Input
                    class="col-24"
                    placeholder="Min title"
                    type="text"
                    :value="item.minlabel"
                    v-model="modal.sliderComponent.questiondef.options[index].minlabel"
                  />

                  <Input
                    class="col-24"
                    placeholder="Max title"
                    type="text"
                    :value="item.maxlabel"
                    v-model="modal.sliderComponent.questiondef.options[index].maxlabel"
                  />
                </div>
              </div>
            </div>

            <div class="col-24">
              <ButtonForm
                class="component-block--array-button"
                title="Add slide"
                v-on:handleClick="handleArrayButtonAdd()"
              />
            </div>
          </div>

          <!-- TextareaComponent -->
          <div
            class="row"
            v-if="data.component === 'TextareaComponent'"
          >
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.textareaComponent.header"
              v-model="modal.textareaComponent.header"
            />

            <Input
              class="col-12"
              placeholder="Max allow"
              type="number"
              :value="modal.textareaComponent.questiondef.meta.maxAllowAdd"
              v-model="modal.textareaComponent.questiondef.meta.maxAllowAdd"
            />

            <div class="col-12 input">
              <p>Allow add</p>

              <SwitchForm 
                :isActive="modal.textareaComponent.questiondef.meta.allowAdd"
                v-model="modal.textareaComponent.questiondef.meta.allowAdd"
              />
            </div>

            <div class="col-24">
              <div
                v-if="modal.textareaComponent.questiondef.options.length === 0"
                class="component-block--array"
              >
                <div class="row">
                  <Input
                    class="col-24"
                    placeholder="Placeholder"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <Input
                    class="col-24"
                    placeholder="Comment"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />
                </div>
              </div>

              <div
                v-for="(item, index) in modal.textareaComponent.questiondef.options"
                v-bind:key="index"
                class="component-block--array"
              >
                <div class="row">
                  <div class="component-block--array--buttons">
                    <a
                      v-if="index !== modal.textareaComponent.questiondef.options.length - 1"
                      class="component-block--array--buttons--down"
                      v-on:click="handleComponentBlockArray(modal.textareaComponent.questiondef.options, item, index, false)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a
                      v-if="index !== 0"
                      class="component-block--array--buttons--up"
                      v-on:click="handleComponentBlockArray(modal.textareaComponent.questiondef.options, item, index, true)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a 
                      class="component-block--array--buttons--trash"
                      v-on:click="handleArrayButtonDelete()"
                    >
                      <TrashIcon/>
                    </a>
                  </div>

                  <Input
                    class="col-24"
                    placeholder="Placeholder"
                    type="text"
                    :value="item.label"
                    v-model="modal.textareaComponent.questiondef.options[index].label"
                  />

                  <Input
                    class="col-24"
                    placeholder="Comment"
                    type="text"
                    :value="item.comment"
                    v-model="modal.textareaComponent.questiondef.options[index].comment"
                  />
                </div>
              </div>
            </div>
            
            <div class="col-24">
              <ButtonForm
                class="component-block--array-button"
                title="Add text"
                v-on:handleClick="handleArrayButtonAdd()"
              />
            </div>
          </div>

          <!-- TextFieldComponent -->
          <div
            class="row"
            v-if="data.component === 'TextfieldComponent'"
          >
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.textFieldComponent.header"
              v-model="modal.textFieldComponent.header"
            />

            <Input
              class="col-12"
              placeholder="Max allow"
              type="number"
              :value="modal.textFieldComponent.questiondef.meta.maxAllowAdd"
              v-model="modal.textFieldComponent.questiondef.meta.maxAllowAdd"
            />

            <div class="col-12 input">
              <p>Allow add</p>

              <SwitchForm 
                :isActive="modal.textFieldComponent.questiondef.meta.allowAdd"
                v-model="modal.textFieldComponent.questiondef.meta.allowAdd"
              />
            </div>
            
            <div class="col-24">
              <div
                v-if="modal.textFieldComponent.questiondef.options.length === 0"
                class="component-block--array"
              >
                <div class="row">
                  <Input
                    class="col-24"
                    placeholder="Text"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <Input
                    class="col-24"
                    placeholder="Comment"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />
                </div>
              </div>

              <div
                v-for="(item, index) in modal.textFieldComponent.questiondef.options"
                v-bind:key="index"
                class="component-block--array"
              >
                <div class="row">
                  <div class="component-block--array--buttons">
                    <a
                      v-if="index !== modal.textFieldComponent.questiondef.options.length - 1"
                      class="component-block--array--buttons--down"
                      v-on:click="handleComponentBlockArray(modal.textFieldComponent.questiondef.options, item, index, false)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a
                      v-if="index !== 0"
                      class="component-block--array--buttons--up"
                      v-on:click="handleComponentBlockArray(modal.textFieldComponent.questiondef.options, item, index, true)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a 
                      class="component-block--array--buttons--trash"
                      v-on:click="handleArrayButtonDelete()"
                    >
                      <TrashIcon/>
                    </a>
                  </div>

                  <Input
                    class="col-24"
                    placeholder="Text"
                    type="text"
                    :value="item.label"
                    v-model="modal.textFieldComponent.questiondef.options[index].label"
                  />

                  <Input
                    class="col-24"
                    placeholder="Comment"
                    type="text"
                    :value="item.comment"
                    v-model="modal.textFieldComponent.questiondef.options[index].comment"
                  />
                </div>
              </div>
            </div>

            <div class="col-24">
              <ButtonForm
                class="component-block--array-button"
                title="Add text"
                v-on:handleClick="handleArrayButtonAdd()"
              />
            </div>
          </div>
          
          <!-- WordgridComponent -->
          <div
            class="row"
            v-if="data.component === 'WordgridComponent'"
          >
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.wordgridComponent.header"
              v-model="modal.wordgridComponent.header"
            />

            <Input
              class="col-12"
              placeholder="Max allow"
              type="number"
              :value="modal.wordgridComponent.questiondef.meta.maxAllowAdd"
              v-model="modal.wordgridComponent.questiondef.meta.maxAllowAdd"
            />

            <div class="col-12 input">
              <p>Allow add</p>

              <SwitchForm 
                :isActive="modal.wordgridComponent.questiondef.meta.allowAdd"
                v-model="modal.wordgridComponent.questiondef.meta.allowAdd"
              />
            </div>

            <div class="col-24">
              <div
                v-if="modal.wordgridComponent.questiondef.options.length === 0"
                class="component-block--array"
              >
                <div class="row">
                  <Input
                    class="col-24"
                    placeholder="Text"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />
                </div>
              </div>

              <div
                v-for="(item, index) in modal.wordgridComponent.questiondef.options"
                v-bind:key="index"
                class="component-block--array"
              >
                <div class="row">
                  <div class="component-block--array--buttons">
                    <a
                      v-if="index !== modal.wordgridComponent.questiondef.options.length - 1"
                      class="component-block--array--buttons--down"
                      v-on:click="handleComponentBlockArray(modal.wordgridComponent.questiondef.options, item, index, false)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a
                      v-if="index !== 0"
                      class="component-block--array--buttons--up"
                      v-on:click="handleComponentBlockArray(modal.wordgridComponent.questiondef.options, item, index, true)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a 
                      class="component-block--array--buttons--trash"
                      v-on:click="handleArrayButtonDelete()"
                    >
                      <TrashIcon/>
                    </a>
                  </div>

                  <Input
                    class="col-24"
                    placeholder="Text"
                    type="text"
                    :value="item.label"
                    v-model="modal.wordgridComponent.questiondef.options[index].label"
                  />
                </div>
              </div>
            </div>

            <div class="col-24">
              <ButtonForm
                class="component-block--array-button"
                title="Add word"
                v-on:handleClick="handleArrayButtonAdd()"
              />
            </div>
          </div>

          <!-- TestComponent -->
          <div
            class="row"
            v-if="data.component === 'TestComponent'"
          >
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.testComponent.header"
              v-model="modal.testComponent.header"
            />

            <div class="col-24 input">
              <p>Positive feedback</p>

              <textarea
                v-model="modal.testComponent.questiondef.feedback.positive"
                placeholder="Positive feedback"
              />
            </div>

           <div class="col-24 input">
              <p>Negative feedback</p>

              <textarea
                v-model="modal.testComponent.questiondef.feedback.negative"
                placeholder="Negative feedback"
              />
            </div>
            
            <div class="col-24">
              <div
                v-if="modal.testComponent.questiondef.choices.length === 0"
                class="component-block--array"
              >
                <div class="row">
                  <Input
                    class="col-24"
                    placeholder="Question"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <Input
                    class="col-12"
                    placeholder="Placeholder false"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />

                  <Input
                    class="col-12"
                    placeholder="Placeholder true"
                    type="text"
                    value=""
                    v-on:handleFocus="handlePlaceholderArrayInputs()"
                  />
                </div>

                <div class="input">
                    <p>Answer is positive</p>

                    <RadioInput
                      placeholder="False"
                      v-on:handleClick="handlePlaceholderArrayInputs()"
                    />
                    
                    <RadioInput
                      placeholder="True"
                      v-on:handleClick="handlePlaceholderArrayInputs()"
                    />
                  </div>
              </div>

              <div
                v-for="(item, index) in modal.testComponent.questiondef.choices"
                v-bind:key="index"
                class="component-block--array"
              >
                <div class="row">
                  <div class="component-block--array--buttons">
                    <a
                      v-if="index !== modal.testComponent.questiondef.choices.length - 1"
                      class="component-block--array--buttons--down"
                      v-on:click="handleComponentBlockArray(modal.testComponent.questiondef.choices, item, index, false)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a
                      v-if="index !== 0"
                      class="component-block--array--buttons--up"
                      v-on:click="handleComponentBlockArray(modal.testComponent.questiondef.choices, item, index, true)"
                    >
                      <ChevronDownIcon/>
                    </a>

                    <a 
                      class="component-block--array--buttons--trash"
                      v-on:click="handleArrayButtonDelete()"
                    >
                      <TrashIcon/>
                    </a>
                  </div>

                  <Input
                    class="col-24"
                    placeholder="Question"
                    type="text"
                    :value="item.label"
                    v-model="modal.testComponent.questiondef.choices[index].label"
                  />
                  
                  <div
                    v-for="(itemOption, indexOption) in item.options"
                    v-bind:key="indexOption"
                    class="col-12"
                  >
                    <Input
                      v-if="indexOption === 0"
                      placeholder="Placeholder false"
                      type="text"
                      v-model="modal.testComponent.questiondef.choices[index].options[indexOption].option"
                    />
                    
                    <Input
                      v-else
                      placeholder="Placeholder true"
                      type="text"
                      v-model="modal.testComponent.questiondef.choices[index].options[indexOption].option"
                    />
                  </div>

                  <div class="col-24 input">
                    <p>Answer is positive</p>

                    <RadioInput
                      placeholder="False"
                      :name="`testComponent${index}`"
                      :checked="modal.testComponent.questiondef.choices[index].options[0].valid"
                      v-on:handleClick="handleRadioInputTestComponent(index, 0, 1)"
                    />
                    
                    <RadioInput
                      placeholder="True"
                      :name="`testComponent${index}`"
                      :checked="modal.testComponent.questiondef.choices[index].options[1].valid"
                      v-on:handleClick="handleRadioInputTestComponent(index, 1, 0)"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-24">
              <ButtonForm
                class="component-block--array-button"
                title="Add question"
                v-on:handleClick="handleArrayButtonAdd()"
              />
            </div>
          </div>

          <!-- add delete component button -->
          <ButtonForm            
            title="Save component"
            v-on:handleClick="handleModalButton()"
          />
        </form>
      </template>
    </Modal>
  </div>
</template>

<script>
  import { API } from '../../services/api.ts'
  import Modal from '../modal/modal.vue'
  import Input from '../form/input.vue'
  import RadioInput from '../form/radio.vue'
  import SwitchForm from '../form/switch.vue'
  import StarInput from '../form/star.vue'
  import ButtonForm from '../form/button.vue'
  import RatioBlockImage from '../ratioBlock/ratioBlockImage.vue'  
  import Search from '../form/search.vue'
  import RoundedButton from '../buttons/roundedButton.vue'
  import TrashIcon from '../../icons/trash.vue'
  import EditIcon from '../../icons/edit.vue'
  import ChevronDownIcon from '../../icons/chevronDown.vue'
  import { Tabs, Tab } from 'vue-tabs-component'
  import SelectionModuleImage from '../storage/selectionModules/image.vue'
  import SelectionModuleVideo from '../storage/selectionModules/video.vue'
  import SelectionModuleMP3 from '../storage/selectionModules/mp3.vue'
  import Audio from '../storage/audio/audio.vue'
  import { component } from 'vue-mce'

  export default {
    name: 'ComponentBlock',
    props: [
      'data'
    ],
    components: {
      Modal,
      Input,
      RadioInput,
      SwitchForm,
      StarInput,
      ButtonForm,
      RatioBlockImage,
      Search,
      RoundedButton,
      TrashIcon,
      EditIcon,
      ChevronDownIcon,
      SelectionModuleImage,
      SelectionModuleVideo,
      SelectionModuleMP3,
      Tabs,
      Tab,
      Audio,
      'vue-mce': component
    },
    data() {
      return {
        config: {
          theme: 'modern',          
          menubar: false,
          plugins: 'code lists link',
          toolbar: 'styleselect | bold italic strikethrough | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat | code',
          style_formats : [
            {title : 'H2', block : 'h2'},
            {title : 'H3', block : 'h3'},
            {title : 'H4', block : 'h4'},
            {title: 'Color block', inline: 'span', classes: 'well', styles: { backgroundColor: 'whitesmoke', display: 'block'}},
            {title : 'Quotation', block : 'blockquote'},
          ]
        },
        images: [],
        search: '',
        modalMedia: {
          isHidden: true
        },
        modal: {
          isHidden: true,
          title: '',
          pageComponent: {
            header: '',
            image: '',
            image_id: 0,
            audio: '',
            audio_id: '',
            videopreview: '',
            video: '',
            videokey: '',
            content: '',
            type: 'Standard'
          },
          answerDisplayComponent: {
            header: '',
            questiondef: {
              meta: {
                allowAdd: false,
                maxAllowAdd: 0
              },
              options: []
            }
          },
          checkBoxComponent: {
            header: '',
            questiondef: {
              meta: {
                allowAdd: false,
                maxAllowAdd: 0
              },
              options: []
            }
          },
          dragAndDropComponent: {
            header: '',
            questiondef: {
              meta: {
                allowAdd: false,
                maxAllowAdd: 0
              },
              options: []
            }
          },
          feedbackComponent: {
            rating: 0
          },
          radioComponent: {
            header: '',
            questiondef: {
              meta: {
                allowAdd: false,
                maxAllowAdd: 0
              },
              options: []
            }
          },
          sliderComponent: {
            header: '',
            questiondef: {
              meta: {
                allowAdd: false,
                maxAllowAdd: 0
              },
              options: []
            }
          },
          textareaComponent: {
            header: '',
            questiondef: {
              meta: {
                allowAdd: false,
                maxAllowAdd: 0
              },
              options: []
            }
          },
          textFieldComponent: {
            header: '',
            questiondef: {
              meta: {
                allowAdd: false,
                maxAllowAdd: 0
              },
              options: []
            }
          },
          wordgridComponent: {
            header: '',
            questiondef: {
              meta: {
                allowAdd: false,
                maxAllowAdd: 0
              },
              options: []
            }
          },
          testComponent: {
            header: '',
            questiondef: {
              choices: [],
              feedback: {
                negative: '',
                positive: ''
              }
            }
          }
        }
      }
    },
    methods: {
      handleStorageSelect: function(image, imageId) {
        let resultImage = this.$el.querySelector('.result-image img');
        this.modal.pageComponent.image = image;
        this.modal.pageComponent.image_id = imageId;
      },
      handleSearchButton: function() {
        API.post(
          `index.cfm?act=images.search`,
          {
            keyword: this.search
          }
        ).then(
          response => {
            this.images = response.data.data.items
            console.log(response.data.data.items)
          }
        )
      },
      handleComponentBlockArray: function(array, arrayItem, index, isUp) {
        const move = function(array, element, delta) {
          var index = array.indexOf(element);
          var newIndex = index + delta;
          
          if (newIndex < 0  || newIndex == array.length) return;
          
          var indexes = [index, newIndex].sort();

          array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
        };

        const moveUp = function(array, element) {
          move(array, element, -1);
        };

        const moveDown = function(array, element) {
          move(array, element, 1);
        };

        const self = this

        if (isUp) {
          moveUp(array, arrayItem);
        } else {
          moveDown(array, arrayItem);
        }

        switch (this.data.component) {
          case 'AnswerDisplayComponent':
            this.modal.answerDisplayComponent.questiondef.options = []

            // TODO: This is hacky and ugly. Try to find a better way.
            setTimeout(function() {
              self.modal.answerDisplayComponent.questiondef.options = array;
            }, 0.5)
            break;

          case 'CheckboxComponent':
            this.modal.checkBoxComponent.questiondef.options = []

            setTimeout(function() {
              self.modal.checkBoxComponent.questiondef.options = array;
            }, 0.5)
            break;

          case 'DragAndDropComponent':
            this.modal.dragAndDropComponent.questiondef.options = []

            setTimeout(function() {
              self.modal.dragAndDropComponent.questiondef.options = array;
            }, 0.5)
            break;

          case 'RadioComponent':
            this.modal.radioComponent.questiondef.options = []

            setTimeout(function() {
              self.modal.radioComponent.questiondef.options = array;
            }, 0.5)
            break;

          case 'SliderComponent':
            this.modal.sliderComponent.questiondef.options = []

            setTimeout(function() {
              self.modal.sliderComponent.questiondef.options = array;
            }, 0.5)
            break;
          
          case 'TextareaComponent':
            this.modal.textareaComponent.questiondef.options = []

            setTimeout(function() {
              self.modal.textareaComponent.questiondef.options = array;
            }, 0.5)
            break;

          case 'TextfieldComponent':
            this.modal.textFieldComponent.questiondef.options = []

            setTimeout(function() {
              self.modal.textFieldComponent.questiondef.options = array;
            }, 0.5)
            break;

          case 'WordgridComponent':
            this.modal.wordgridComponent.questiondef.options = []

            setTimeout(function() {
              self.modal.wordgridComponent.questiondef.options = array;
            }, 0.5)
            break;
          
          case 'TestComponent':
            this.modal.testComponent.questiondef.choices = []

            setTimeout(function() {
              self.modal.testComponent.questiondef.choices = array;
            }, 0.5)
            break;
        
          default:
            break;
        }
      },
      handleModal: function() {
        if (this.data.component === 'PageComponent') {
          this.modal.pageComponent.header = this.data.title;
          this.modal.pageComponent.image = this.data.image;
          this.modal.pageComponent.image_id = this.data.image_id;
          this.modal.pageComponent.audio = this.data.audio;
          this.modal.pageComponent.audio_id = this.data.audio_id;
          this.modal.pageComponent.videopreview = this.data.videopreview;
          this.modal.pageComponent.video = this.data.key;
          this.modal.pageComponent.content = this.data.content;
          this.modal.pageComponent.type = this.data.type;
        }

        if (this.data.component === 'AnswerDisplayComponent') {
          this.modal.answerDisplayComponent.header = this.data.title;
          
          if (typeof(this.data.questiondef.meta) == 'object') {
            this.modal.answerDisplayComponent.questiondef = this.data.questiondef;
          }
        }

        if (this.data.component === 'CheckboxComponent') {
          this.modal.checkBoxComponent.header = this.data.title;

          if (typeof(this.data.questiondef.meta) == 'object') {
            this.modal.checkBoxComponent.questiondef = this.data.questiondef;
          }
        }

        if (this.data.component === 'DragAndDropComponent') {
          this.modal.dragAndDropComponent.header = this.data.title;
          
          if (typeof(this.data.questiondef.meta) == 'object') {
            this.modal.dragAndDropComponent.questiondef = this.data.questiondef;
          }
        }

        if (this.data.component === 'FeedbackComponent') {
          // this.modal.feedbackComponent.rating = this.data.rating;
        }

        if (this.data.component === 'RadioComponent') {
          this.modal.radioComponent.header = this.data.title;          
          
          if (typeof(this.data.questiondef.meta) == 'object') {
            this.modal.radioComponent.questiondef = this.data.questiondef;
          }
        }

        if (this.data.component === 'SliderComponent') {
          this.modal.sliderComponent.header = this.data.title;

          if (typeof(this.data.questiondef.meta) == 'object') {
            this.modal.sliderComponent.questiondef = this.data.questiondef;
          }
        }

        if (this.data.component === 'TextareaComponent') {
          this.modal.textareaComponent.header = this.data.title;
          
          if (typeof(this.data.questiondef.meta) == 'object') {
            this.modal.textareaComponent.questiondef = this.data.questiondef;
          }
        }

        if (this.data.component === 'TextfieldComponent') {
          this.modal.textFieldComponent.header = this.data.title;
          
          if (typeof(this.data.questiondef.meta) == 'object') {
            this.modal.textFieldComponent.questiondef = this.data.questiondef;
          }
        }

        if (this.data.component === 'WordgridComponent') {
          this.modal.wordgridComponent.header = this.data.title;
          
          if (typeof(this.data.questiondef.meta) == 'object') {
            this.modal.wordgridComponent.questiondef = this.data.questiondef;
          }
        }

        if (this.data.component === 'TestComponent') {
          this.modal.testComponent.header = this.data.title;
          this.modal.testComponent.questiondef = this.data.questiondef;

          console.log(this.data.questiondef)
        }

        if (this.modal.isHidden === true) {
          this.modal.isHidden = false;
        } else {
          this.modal.isHidden = true;
        }
      },
      handleModalMedia: function() {
        if (this.modalMedia.isHidden === true) {
          this.modalMedia.isHidden = false;
        } else {
          this.modalMedia.isHidden = true;
        }
      },
      handleModalRemoveMedia: function() {
        this.modal.pageComponent.image = '';
        this.modal.pageComponent.image_id = 0;
        this.modal.pageComponent.audio = '';
        this.modal.pageComponent.audio_id = '';
        this.modal.pageComponent.videopreview = '';
        this.modal.pageComponent.video = '';
        this.modal.pageComponent.videokey = '';
      },
      handleSelectionModuleImageClick: function(item) {
        this.modal.pageComponent.image = item.url;
        this.modal.pageComponent.image_id = item.id;
        this.modal.pageComponent.audio = '';
        this.modal.pageComponent.audio_id = '';
        this.modal.pageComponent.videopreview = '';
        this.modal.pageComponent.video = '';
        this.modal.pageComponent.videokey = '';

        this.modalMedia.isHidden = true
      },
      handleSelectionModuleVideoClick: function(item) {
        this.modal.pageComponent.image = '';
        this.modal.pageComponent.image_id = '';
        this.modal.pageComponent.audio = '';
        this.modal.pageComponent.audio_id = '';
        this.modal.pageComponent.videopreview = item.preview;
        this.modal.pageComponent.video = item.title;
        this.modal.pageComponent.videokey = item.key;

        console.log(item);

        this.modalMedia.isHidden = true
      },
      handleSelectionModuleMP3Click: function(item) {
        console.log(item);
        this.modal.pageComponent.image = '';
        this.modal.pageComponent.image_id = '';
        this.modal.pageComponent.audio = item.url;
        this.modal.pageComponent.audio_id = item.id;
        this.modal.pageComponent.videopreview = '';
        this.modal.pageComponent.video = '';
        this.modal.pageComponent.videokey = '';

        this.modalMedia.isHidden = true
      },
      handleRadioChecked: function(componentName) {
        if (this.modal.pageComponent.type === componentName) {
          return true;
        } else {
          return false;
        }
      },
      handleRadioInput: function(componentName) {
        this.modal.pageComponent.type = componentName;
      },
      handleRadioInputCheckboxComponent: function(input, index) {
        
        this.modal.checkBoxComponent.questiondef.options[index].result = Number(input);
      },
      handleRadioInputRadioComponent: function(input, index) {
        this.modal.radioComponent.questiondef.options[index].result = input;
      },
      handleRadioInputDragAndDropComponent: function(input, index) {        
        this.modal.dragAndDropComponent.questiondef.options[index].result = input;
      },
      handleRadioInputTestComponent: function(index, radioNumber, radioNumberOther) {
        this.modal.testComponent.questiondef.choices[index].options[radioNumber].valid = true
        this.modal.testComponent.questiondef.choices[index].options[radioNumberOther].valid = false
      },
      handleTestInputComponent: function(input, index, indexOption) {
        this.modal.testComponent.questiondef.choices[index].options[indexOption].valid = input;
      },
      handlePlaceholderArrayInputs: function(input) {
        if (this.modal.answerDisplayComponent.questiondef.options.length == 0) {
          this.handleArrayButtonAdd();
        }
      },
      handleArrayButtonAdd: function() {
        if (this.data.component === 'AnswerDisplayComponent') {
          this.modal.answerDisplayComponent.questiondef.options.push(
            {
              page: 0,
              excercise: 0
            }
          );
        }

        if (this.data.component === 'CheckboxComponent') {
          this.modal.checkBoxComponent.questiondef.options.push(
            {
              label: '',
              result: undefined,
              feedback: ''
            }
          );
        }

        if (this.data.component === 'DragAndDropComponent') {
          this.modal.dragAndDropComponent.questiondef.options.push(
            {
              label: '',
              result: 0,
              feedback: ''
            }
          );
        }

        if (this.data.component === 'RadioComponent') {
          this.modal.radioComponent.questiondef.options.push(
            {
              label: '',
              result: false,
              feedback: ''
            }
          );
        }

        if (this.data.component === 'SliderComponent') {
          this.modal.sliderComponent.questiondef.options.push(
            {
              label: '',
              minvalue: 0,
              minlabel: '',
              maxvalue: 0,
              maxlabel: '',
              step: 0
            }
          );
        }

        if (this.data.component === 'TextareaComponent') {
          this.modal.textareaComponent.questiondef.options.push(
            {
              
              label: '',
              comment: ''
            }
          );
        }

        if (this.data.component === 'TextfieldComponent') {
          this.modal.textFieldComponent.questiondef.options.push(
            {
              text: '',
              comment: ''
            }
          );
        }

        if (this.data.component === 'WordgridComponent') {
          this.modal.wordgridComponent.questiondef.options.push(
            {
              label: ''
            }
          );
        }

        if (this.data.component === 'TestComponent') {
          this.modal.testComponent.questiondef.choices.push(
            {
              label: '',
              options: [
                {
                  option: '',
                  valid: false
                },
                {
                  option: '',
                  valid: false
                }
              ]
            }
          );
        }
      },
      handleArrayButtonDelete: function(index, id) {
        if (this.data.component === 'AnswerDisplayComponent') {
          this.modal.answerDisplayComponent.questiondef.options.splice(index, 1);
        }

        if (this.data.component === 'CheckboxComponent') {
          this.modal.checkBoxComponent.questiondef.options.splice(index, 1);
        }

        if (this.data.component === 'DragAndDropComponent') {
          this.modal.dragAndDropComponent.questiondef.options.splice(index, 1);
        }

        if (this.data.component === 'RadioComponent') {
          this.modal.radioComponent.questiondef.options.splice(index, 1);
        }

        if (this.data.component === 'SliderComponent') {
          this.modal.sliderComponent.questiondef.options.splice(index, 1);
        }

        if (this.data.component === 'TextareaComponent') {
          this.modal.textareaComponent.questiondef.options.splice(index, 1);
        }

        if (this.data.component === 'TextfieldComponent') {
          this.modal.textFieldComponent.questiondef.options.splice(index, 1);
        }

        if (this.data.component === 'WordgridComponent') {
          this.modal.wordgridComponent.questiondef.options.splice(index, 1);
        }

        if (this.data.component === 'TestComponent') {
          this.modal.testComponent.questiondef.choices.splice(index, 1);
        }
      },
      handleModalButton: function() {
        let patchObject = {};

        if (this.data.component === 'PageComponent') {
          patchObject = {
            title: this.modal.pageComponent.header,
            image: this.modal.pageComponent.image,
            image_id: this.modal.pageComponent.image_id,
            audio: this.modal.pageComponent.audio,
            audio_id: this.modal.pageComponent.audio_id,
            video: this.modal.pageComponent.videokey,
            content: this.modal.pageComponent.content,
            type: this.modal.pageComponent.type
          };
        }

        if (this.data.component === 'AnswerDisplayComponent') {
          patchObject = {
            title: this.modal.answerDisplayComponent.header,
            questiondef: this.modal.answerDisplayComponent.questiondef
          }
        }

        if (this.data.component === 'CheckboxComponent') {
          patchObject = {
            title: this.modal.checkBoxComponent.header,
            questiondef: this.modal.checkBoxComponent.questiondef
          }
        }
        
        if (this.data.component === 'DragAndDropComponent') {
          patchObject = {
            title: this.modal.dragAndDropComponent.header,
            questiondef: this.modal.dragAndDropComponent.questiondef
          }
        }

        if (this.data.component === 'FeedbackComponent') {
          patchObject = {
            // rating: this.modal.feedbackComponent.rating
          }
        }
        
        if (this.data.component === 'RadioComponent') {
          patchObject = {
            title: this.modal.radioComponent.header,
            questiondef: this.modal.radioComponent.questiondef
          }
        }

        if (this.data.component === 'SliderComponent') {
          patchObject = {
            title: this.modal.sliderComponent.header,
            questiondef: this.modal.sliderComponent.questiondef
          }
        }

        if (this.data.component === 'TextareaComponent') {
          patchObject = {
            title: this.modal.textareaComponent.header,
            questiondef: this.modal.textareaComponent.questiondef
          }
        }

        if (this.data.component === 'TextfieldComponent') {
          patchObject = {
            title: this.modal.textFieldComponent.header,
            questiondef: this.modal.textFieldComponent.questiondef
          }
        }

        if (this.data.component === 'WordgridComponent') {
          patchObject = {
            title: this.modal.wordgridComponent.header,
            questiondef: this.modal.wordgridComponent.questiondef
          }
        }

        if (this.data.component === 'TestComponent') {
          patchObject = {
            title: this.modal.testComponent.header,
            questiondef: this.modal.testComponent.questiondef
          }
        }

        console.log(patchObject);

        API.patch(
          `index.cfm?act=lessonpageblocks.item&id=${this.data.id}`,
          patchObject
        ).then(
          response => {
            console.log(response);

            if (this.data.component === 'PageComponent') {
              this.data.title = response.data.data.title;
              this.data.image = response.data.data.image;
              this.data.image_id = response.data.data.image_id;
              this.data.audio = response.data.data.audio;
              this.data.audio_id = response.data.data.audio_id;
              this.data.video = response.data.data.video;
              this.data.videopreview = response.data.data.videopreview;
              this.data.videoKey = response.data.data.videoKey;
              this.data.content = response.data.data.content;
              this.data.type = response.data.data.type;
            }

            if (this.data.component === 'AnswerDisplayComponent') {
              this.data.title = response.data.data.title;
              this.data.questiondef = response.data.data.questiondef;
            }

            if (this.data.component === 'CheckboxComponent') {
              this.data.title = response.data.data.title;
              this.data.questiondef = response.data.data.questiondef;
            }

            if (this.data.component === 'DragAndDropComponent') {
              this.data.title = response.data.data.title;
              this.data.questiondef = response.data.data.questiondef;
            }

            if (this.data.component === 'FeedbackComponent') {
              // this.data.rating = response.data.data.rating;
            }

            if (this.data.component === 'RadioComponent') {
              this.data.title = response.data.data.title;
              this.data.questiondef = response.data.data.questiondef;
            }

            if (this.data.component === 'SliderComponent') {
              this.data.title = response.data.data.title;
              this.data.questiondef = response.data.data.questiondef;
            }

            if (this.data.component === 'TextareaComponent') {
              this.data.title = response.data.data.title;
              this.data.questiondef = response.data.data.questiondef;
            }

            if (this.data.component === 'TextFieldComponent') {
              this.data.title = response.data.data.title;
              this.data.questiondef = response.data.data.questiondef;
            }

            if (this.data.component === 'WordgridComponent') {
              this.data.title = response.data.data.title;
              this.data.questiondef = response.data.data.questiondef;
            }

            if (this.data.component === 'TestComponent') {
              this.data.title = response.data.data.title;
              this.data.questiondef = response.data.data.questiondef;
            }

            this.modal.isHidden = true;
          }
        )
      },
    },
    mounted() {
      API.post(
        `index.cfm?act=images.search`
      ).then(
        response => {
          const pages = Math.ceil(response.data.data.totalItems / 30)
          
          this.images = response.data.data.items;
        }
      )
    }
  }
</script>

<style lang="scss">
  .component-block {
    background-color: var(--white);
    border-radius: 3px;
    padding: 15px;
    width: 100%;
    margin-bottom: 15px;
    overflow: hidden;

    &--heading {
      h3 {
        display: inline-block;
        font-size: 18px;
      }

      a {
        font-weight: bold;
        float: right;
        margin-left: 10px;
      }
    }

    &--content {
      
      div {
        margin-top: 10px;

        img {
          margin-top: 5px;
        }
      }

      &--array {
        border: 1px solid var(--blue-medium);
        padding: 15px;
      }
    }

    &--array {
      border: 1px solid var(--blue-medium);
      padding: 15px 15px 0 15px;
      margin-bottom: 15px;
      position: relative;
      width: 100%;

      &--buttons {
        position: absolute;
        top: 15px;
        right: 15px;

        a {
          display: inline-block;
          font-weight: bold;
          cursor: pointer;
          margin-left: 8px;
        }

        &--down,
        &--up {
          svg {
            path {
              fill: var(--blue);
            }
          }
        }

        &--down {
          padding-bottom: 2px;
        }

        &--up {
          transform: rotate(180deg);
          padding-bottom: 2px;
        }

        &--trash {
          svg {
            path {
              fill: var(--red);
            }
          }
        }
      }

      .switch {
        margin-bottom: 15px;
      }
    }
    
    &--array-button {
      margin-bottom: 15px;
      background-color: var(--black);
    }

    &--remove-button {
      margin-bottom: 15px;
      margin-top: 10px;
      background-color: var(--red);
    }

    .modal {
      cursor: default;
    }
  }

  .tabs-component-tabs {
    display: flex;

    li {
      display: inline-block;
      font-weight: bold;
      padding: 10px;
      width: 100%;
      border-bottom: 2px solid var(--grey-light);

      a {
        text-align: center;
        display: block;
      }
    }

    .is-active {
      border-bottom: 2px solid var(--blue);
    }
  }

  .tabs-component-panels {
    margin-top: 15px;

    .selection-module-image,
    .selection-module-document,
    .selection-module-video {
      max-height: 400px;
    }

    .search {
      width: 100% !important;
    }
  }
</style>
